<template>
  <div class="header__Modal">
    <h3 v-text="$t('header.contact')" />
    <div class="header__ModalSection">
      <div class="header__ModalSectionForm absoluteLabelsForm">
        <h4 v-text="$t('contactForm.title')" />
        <p v-text="$t('contactForm.lead')" />
        <SelectField v-model="selectedCategory" :options="categories" :label="$t('header.selectCategory')" text-key="text" value-key="value" />
        <Button type="button" medium full-width @click="goToContact">{{ $t('header.contactUs') }}</Button>
      </div>

      <div v-if="contact?.phone_number">
        <h4 v-text="$t('header.phone')" />
        <a :href="'tel:' + contact.phone_number" v-text="contact.phone_number" class="header__ModalPhoneNumber button__Text--Underline" />
        <p v-if="contact.working_hours" v-text="contact.working_hours" class="header__ModalHours" />
      </div>

      <div>
        <h4 v-text="$t('header.help')" />
        <nuxt-link :to="link('FAQ')" class="button__Text--Underline">{{ $t('header.findAnswers') }}</nuxt-link>
      </div>
    </div>
  </div>
</template>

<script setup>
  const { initialData, link } = useSetup();
  const { t } = useI18n();
  const contact = computed(() => initialData.value.contact);
  const router = useRouter();
  const route = useRoute();

  const emit = defineEmits(['closeContactDropdown']);

  const categories = ref([
    {
      text: t('contactFormCategories.newReservation'),
      value: 'NEW_RESERVATION',
    },
    {
      text: t('contactFormCategories.modifyReservation'),
      value: 'MODIFY_RESERVATION',
    },
    {
      text: t('contactFormCategories.cancelReservation'),
      value: 'CANCEL_RESERVATION',
    },
    {
      text: t('contactFormCategories.lostItems'),
      value: 'LOST_ITEMS',
    },
    {
      text: t('contactFormCategories.propertyInfo'),
      value: 'PROPERTY_INFO',
    },
    {
      text: t('contactFormCategories.other'),
      value: 'OTHER',
    },
  ]);
  const selectedCategory = ref(null);

  if(route?.query?.type) {
    selectedCategory.value = route.query.type;
  }

  function goToContact() {
    router.push(`${link('ContactForm')}?type=${selectedCategory.value || ''}`);
    emit('closeContactDropdown');
  }

  watch(() => route, (newValue) => {
    selectedCategory.value = newValue?.query?.type || null;
  }, {
    deep: true,
  });
</script>